import { render, staticRenderFns } from "./lostFound.vue?vue&type=template&id=21d005fc&scoped=true&"
import script from "./lostFound.vue?vue&type=script&lang=js&"
export * from "./lostFound.vue?vue&type=script&lang=js&"
import style0 from "./lostFound.vue?vue&type=style&index=0&id=21d005fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d005fc",
  null
  
)

export default component.exports